import api from "./api";

const StockOutReportService = {
  getReport: async (params) => {
    const response = await api.get("/stockOutReport/getReport", {
      params: {
        companyId: params.companyId || undefined,
        projectCategoryId: params.projectCategoryId || undefined,
        projectId: params.projectId || undefined,
        storeId: params.storeId || undefined,
        locationId: params.locationId || undefined,
        startDate: params.startDate || undefined,
        endDate: params.endDate || undefined,
        employeeId: params.employeeId || undefined,
        roleId: params.roleId || undefined,
        status: params.status || undefined,
        page: params.page || 1,
        limit: params.limit || 10,
      },
    });

    return response.data;
  },
};

export default StockOutReportService;
